import React from 'react';
import { Add, People, NotificationsActive } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

interface ParticipantsHeaderProps {
    onAddParticipant: () => void;
    onSendReminders?: () => void;
    lateParticipantsCount?: number;
}

export const ParticipantsHeader: React.FC<ParticipantsHeaderProps> = ({
    onAddParticipant,
    onSendReminders,
    lateParticipantsCount = 0
}) => {
    return (
        <div className="section-header">
            <div className="section-icon">
                <People />
            </div>
            <h2 className="section-title">Participants du projet</h2>

            <div className="header-actions">
                {onSendReminders && lateParticipantsCount > 0 && (
                    <Tooltip title={`Relancer ${lateParticipantsCount} retardataire${lateParticipantsCount > 1 ? 's' : ''}`}>
                        <button
                            className="header-btn warning"
                            onClick={onSendReminders}
                        >
                            <NotificationsActive />
                            <span className="btn-badge">{lateParticipantsCount}</span>
                        </button>
                    </Tooltip>
                )}
                <Tooltip title="Ajouter un participant">
                    <button className="header-btn primary" onClick={onAddParticipant}>
                        <Add />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};
